import React from "react";
import { appHost } from "../../helpers/uri";
import { Button } from "../../components/ui/Button";
import { FiPrinter } from "react-icons/fi";

const PrintReceipt = ({ v }) => {
  const _show = () => {
    window.open(`${appHost}application-receipt/${v?._id}`, `Student Module Registration Window`, `_parent`, `width=450,height=650`);
  };
  return (
    <Button
      variant="primary"
      size="sm"
      onClick={_show}
      leftIcon={<FiPrinter />}
    >
      Print Application Slip
    </Button>
  );
};

export default PrintReceipt;
